import { Pipe, PipeTransform } from "@angular/core"
import { environment } from "@env/environment"

@Pipe({
	name: "serverImg",
})
export class ServerImgPipe implements PipeTransform {
	transform(id: any, type: string, cacheBust: boolean = false) {
		const cachePart = cacheBust ? `?t=${Math.random()}` : ``
		const idPart = id ? `/${id}` : ``
		return `${environment.serverUrl}/${type}${idPart}${cachePart}`
	}
}
